import { AsideMenuMain } from '../aside-menu-main';
import { AsideMenuList } from './AsideMenuList';
import { DrawerComponent } from 'components/layout/initializers/drawer-component';
import { ScrollComponent } from 'components/layout/initializers/scroll-component';
import { ToggleComponent } from 'components/layout/initializers/toggle-component';
import { MenuComponent } from 'components/layout/menu';
import { useEffect } from 'react';

export const ConfigurationTab = () => {
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization();
      DrawerComponent.reinitialization();
      ToggleComponent.reinitialization();
      ScrollComponent.reinitialization();
    }, 50);
  }, []);

  return (
    <div
      className="menu menu-column menu-fit menu-rounded menu-title-gray-800 menu-icon-gray-400 menu-state-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 fw-bold fs-5 px-6 my-5 my-lg-0"
      id="kt_aside_menu"
      data-kt-menu="true"
    >
      <div id="kt_aside_menu_wrapper" className="menu-fit">
        <AsideMenuList />
      </div>
    </div>
  );
};
